import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../utils/config-service';
import { GlobalName } from '../utils/global-name';

@Injectable({
  providedIn: 'root'
})
export class UploadService {

  constructor(private http:HttpClient) { }

  

  store(ressource:any){
    return this.http.post<any>(`${ConfigService.toApiUrl("v1/upload-file")}`,ressource,
     ConfigService.httpHeader(localStorage.getItem(GlobalName.tokenName),true));
  }

  get(){
    return this.http.get<any>(`${ConfigService.toApiUrl("v1/delete-file")}`,
     ConfigService.httpHeader(localStorage.getItem(GlobalName.tokenName),true));
  }

 
}
